import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar, Popover, Spin, Tag } from "antd";
import { useEffect, useState } from "react";
import { EUserRole } from "@devowl-wp/api-real-cookie-banner";
import { useGetServiceTemplateLastEditorsSinceRelease } from "../../../../hooks/service/useServiceTemplateGetEditorsSinceRelease.js";
import { RcbAvatar } from "../rcb-avatar.js";
import { PermissionCheck } from "./permission.js";
import { useGetContentBlockerTemplateLastEditorsSinceRelease } from "../../../../hooks/content-blocker/useContentBlockerTemplateGetEditorsSinceRelease.js";
import { useTranslation } from "../../../../others/i18n.js";
import { useStores } from "../../../../store/root.js";
const UserTagLastEditors = ({ lastKnownEditor, templateId, type, disabled = false })=>{
    const { t } = useTranslation();
    const { rcbAuthenticationStore } = useStores();
    const hasCreatorRole = rcbAuthenticationStore.hasRole(EUserRole.Creator);
    const [lastEditors, setLastEditors] = useState([]);
    const [loadUser, setLoadUser] = useState(!lastKnownEditor);
    const { data: serviceEditorData, isFetching: serviceDataFetching } = useGetServiceTemplateLastEditorsSinceRelease(templateId, hasCreatorRole && loadUser && type === "Service" && !disabled);
    useEffect(()=>{
        setLastEditors(serviceEditorData?.lastEditors || []);
    }, [
        serviceEditorData
    ]);
    const { data: blockerEditorData, isFetching: blockerDataFetching } = useGetContentBlockerTemplateLastEditorsSinceRelease(templateId, hasCreatorRole && loadUser && type === "Content-Blocker" && !disabled);
    useEffect(()=>{
        setLastEditors(blockerEditorData?.lastEditors || []);
    }, [
        blockerEditorData
    ]);
    return /*#__PURE__*/ _jsx(PermissionCheck, {
        minRole: EUserRole.Creator,
        children: /*#__PURE__*/ _jsx(Popover, {
            content: /*#__PURE__*/ _jsx(Spin, {
                spinning: serviceDataFetching || blockerDataFetching,
                children: /*#__PURE__*/ _jsx(Avatar.Group, {
                    children: lastEditors?.map((user)=>/*#__PURE__*/ _jsx(RcbAvatar, {
                            user: user,
                            placement: "bottom"
                        }, user?.emailMd5))
                })
            }),
            title: t("Edited since the last release by"),
            trigger: "hover",
            placement: "leftTop",
            children: /*#__PURE__*/ _jsx("div", {
                style: {
                    display: "initial"
                },
                hidden: !(lastEditors?.length > 0) && !lastKnownEditor,
                children: /*#__PURE__*/ _jsx(Tag, {
                    onMouseEnter: ()=>setLoadUser(true),
                    children: lastKnownEditor ? `${lastKnownEditor.firstName} ${lastKnownEditor.lastName}` : `${lastEditors[0]?.firstName} ${lastEditors[0]?.lastName}`
                })
            })
        })
    });
};
export { UserTagLastEditors };
